<template>
  <div>
    <LoadingQuote
      v-if="showQuoteLoading"
      :loading-complete="!isQuoteLoading"
      @loadingAnimationIsComplete="completeQuoteLoading"
    />
    <template v-else>
      <h6>{{ $t('message.insurance.insuranceWrapperHeader') }}</h6>
      <MobialisProgressBar
        v-if="$route.meta.navInfo"
        class="mb-4"
        :numberOfSteps="$route.meta.numberOfSteps"
        :navInfo="$route.meta.navInfo"
      ></MobialisProgressBar>
      <MobialisHorizontalRule v-if="!$route.meta.navInfo" class="mt-2 mb-4"></MobialisHorizontalRule>
      <CurrentVehicleSelection></CurrentVehicleSelection>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CurrentVehicleSelection from '@/components/insurance/CurrentVehicleSelection.vue';
import LoadingQuote from '@/components/insurance/LoadingQuote.vue';

export default {
  name: 'InsuranceWrapperMobile',
  components: {
    CurrentVehicleSelection,
    LoadingQuote,
  },
  mounted() {
    // A hacky way to fix the weird IOS blank page issue
    // when a user comes from DHS, insurance flow is blank (but DOM is existing!)
    // Force to re-render the app
    if (this.isAVRMobile) {
      document.body.style.height = 'initial';
      this.$nextTick(() =>
        setTimeout(() => {
          document.body.style.height = '';
        }, 10)
      );
    }
  },
  computed: {
    ...mapGetters('insurance', ['isQuoteLoading', 'showQuoteLoading']),
  },
  methods: {
    completeQuoteLoading() {
      this.$store.commit('insurance/SET_SHOW_QUOTE_LOADING', false);
    },
  },
};
</script>

<style lang="scss" scoped>
h6 {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}
.custom-mb {
  margin-bottom: 29px;
}
</style>
